import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { addAlertMessage } from './alert-messages';
import { AlertMessageType } from 'redux/schemas/app/alert-message';
import t from 'react-translate';

export const fetchCourseWaitlist = createAsyncThunk('GET_COURSE_WAITLIST',
  async (params: { catalogId: string; userId: string | undefined }) => {
    const { catalogId, userId } = params;
    const response = await axios.get(`/courses/${catalogId}/enrollment_waitlist_entries${userId ? `?user_id=${userId}` : ''}`);

    return response.data.result;
  });

export const joinWaitlist = createAsyncThunk('JOIN_WAITLIST',
  async (catalogId: string, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(`/courses/${catalogId}/enrollment_waitlist_entries`);
      return response.data.result;
    } catch (error) {
      dispatch(
        addAlertMessage({
          type: AlertMessageType.ERROR,
          header: t.FORM.ERROR_SOMETHING_WRONG(),
        }),
      );

      return rejectWithValue(error);
    }
  });

export const abandonWaitlist = createAsyncThunk('ABANDON_WAITLIST',
  async (catalogId: string, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete(`/courses/${catalogId}/enrollment_waitlist_entries`);
      return response.data.result;
    } catch (error) {
      dispatch(
        addAlertMessage({
          type: AlertMessageType.ERROR,
          header: t.FORM.ERROR_SOMETHING_WRONG(),
        }),
      );

      return rejectWithValue(error);
    }
  });

export const removeEnrolledLearnersFromWaitlist = createAction<number[]>('REMOVE_ENROLLED_LEARNERS_FROM_WAITLIST');

export default fetchCourseWaitlist;
